import { enableFade } from 'core/handlers/FadeEntityHandler'
import { signal } from 'services/SignalsService'
import { activationSettings } from 'settings/custom/activations'

export function enableActivation(object) {
  function makeActivation(value) {
    return function () {
      object.activate(value)
    }
  }

  function subscribe([sig, value]) {
    signal.on(sig, makeActivation(value))
  }

  const settings = activationSettings[object.name]
  let fade = false
  if (settings) {
    if(settings.fade) {
      fade = enableFade(object)
    }

    object.activate = function (value) {

      if(settings.fade) {
        if(value){
          object.visibility(value, 'activation')
        }
        if(fade){
          fade(value, () => {
            object.visibility(value, 'activation')
          })
        }

      }
      else{
        object.visibility(value, 'activation')

      }

    }

    object.activate(settings.default)

    Object.entries(settings).forEach(subscribe)
  }

}
